export const slidesFolderKeys = {
  all: ["slides-folder"] as const,
  slidesFolders: ["slides-folder", "list"] as const,
  archivedSlidesFolders: ["slides-folder", "list", "archived"] as const,
  slidesFolder: (id: string) => ["slides-folder", "folder", id] as const,
};
